import Constants from 'api-constants'
/**
 * @class Nagra Product
 * @documentation https://docs.nagra.com/doc/otv/otvdoc2051/apis/
 */
export class NagraProduct {
    constructor(props) {
        const startPurchase = props.startPurchase || (props.price && props.price.startPurchase)
        const endPurchase = props.endPurchase || (props.price && props.price.endPurchase)
        /** @type {String} */
        this.id = props.id
        /** @type {String} */
        this.type = props.type
        /** @type {String} */
        this.currency = props.price && props.price.currency
        /** @type {Number} */
        this.price = props.price && props.price.value
        /** @type {Date} */
        this.startPurchase = this.parseDate(startPurchase)
        /** @type {Date} */
        this.endPurchase = this.parseDate(endPurchase)
        /** @type {Number} Computed*/
        this.purchaseDurationMs = (endPurchase - startPurchase) * 1000
        /** @type {Number} */
        this.rentalDurationMs = props.rentalDuration * 1000
        /** @type {Date} */
        this.startValidity = this.parseDate(props.startValidity)
        /** @type {Date} */
        this.endValidity = this.parseDate(props.endValidity)
        /** @type {String} */
        this.title = props.Title
        /** @type {String} */
        this.title2 = props.title
        /** @type {String} */
        this.description = props.Description
        /** @type {Boolean} */
        this.impulsive = props.impulsive
        /** @type {Boolean} */
        this.isFreemium = props.isFreemium
        /** @type {Boolean} */
        this.isShared = props.isShared
        /** @type {String} */
        this.PriceGroup = props.PriceGroup
        /** @type {Array<String>} for VOD Only */
        this.technicalTypes = props.technicalTypes
    }

    static TYPE = {
        TRANSACTIONAL: 'transactional',
        SUBSCRIPTION: 'subscription',
    }

    static SERVICE_TYPE = {
        BTV: 'btv',
        VOD: 'vod',
    }

    parseDate(ts) {
        if (ts && typeof ts === 'string') {
            return new Date(ts)
        } else if (ts && typeof ts === 'number') {
            return new Date(ts * 1000)
        }
        return ts
    }

    static getProductType(productType) {
        switch (productType) {
            case Constants.productTypes.SUBSCRIPTION:
                return NagraProduct.TYPE.SUBSCRIPTION
            case Constants.productTypes.TRANSACTIONAL:
                return NagraProduct.TYPE.TRANSACTIONAL
            default:
                return undefined
        }
    }
}
